import { GroupChat } from '../models/GroupChat';
import { Pleb } from '../models/Pleb';
import { FakeData } from './FakeData';
import { Repository } from './Repository';

export class GroupRepository extends Repository {

  async getGroupDetails(id: string, channelType: string = 'group', currentUserId: string, excludeMembers: boolean = false): Promise<GroupChat> {
    if(Repository.offlineMode) {
      return FakeData.getGroupChat();
    }

    const path = `v1/chats/groups/${id}?excludeMembers=${excludeMembers}&channelType=${channelType}`;

    try {
      const response = await Repository.client.get(path);
      return GroupChat.fromJson(response.data.data.groupChat, currentUserId);
    } catch (err) {
      throw err;
    }
  }

  async getGroupMembers(id: string, channelType: string, currentUserId: string, offset: number = 0, limit: number = 100): Promise<{members: Pleb[], hasMore: boolean}> {
    const path = `v1/chats/groups/members/${id}?channelType=${channelType}&offset=${offset}&limit=${limit}&excludeNonSubscribers=true`;
  
    try {
      const response = await Repository.client.get(path);
      return {
        members: (response.data.data.members as Array<any>)
          .map(member => Pleb.fromJson(member, currentUserId || '' ))
          .filter(member => member !== null) as Pleb[],
        hasMore: response.data.data.hasMore
      };
    } catch (err) {
      throw err;
    }
  }


  async addMember(groupChatId: string, memberId: string, excludeMembers: boolean = false): Promise<void> {
    const path = `v1/chats/groups/${groupChatId}/members/${memberId}?excludeMembers=${excludeMembers}`;
    await Repository.client.put(path);
  }
}

// Create a singleton instance
export const groupRepository = new GroupRepository();